import { useState } from 'react';
import { isEmpty, uniqBy, filter } from 'lodash';
import Spinner from './Spinner';

export default function DiscountCodes({ discountCodes, setDiscountCodes, contingents, TICKETING_BASE_URL }) {
    const [dcInput, setDcInput] = useState('');
    const [verifyingDiscountCode, setVerifyingDiscountCode] = useState(false);
    const [codeInvalid, setCodeInvalid] = useState(false);

    function addDiscountCodes(discountCodesToAdd) {
        setDiscountCodes(uniqBy([...discountCodes, ...discountCodesToAdd], 'code'));
    }

    function removeDiscountCode(discountCode) {
        setDiscountCodes(filter(discountCodes, dc => dc.code != discountCode.code));
    }
    
    function verifyDiscountCode(code) {
        setVerifyingDiscountCode(true);

        var resetDiscountCode = function () {
					  // let discountCodes = [];
					  setCodeInvalid(false);
				};

        
				let params = '?';
				for (let contingent of contingents) {
					  params += 'contingent=' + contingent.id + '&';
				}
				
				fetch(TICKETING_BASE_URL + '/tickets/api/discount-codes/' + encodeURIComponent(code) + params, { method: 'GET', })
					  .then(function (res) {
						    setVerifyingDiscountCode(false);
						    if (!res.ok) {
							      setTimeout(function () {
								        resetDiscountCode();
							      }, 0);
						    } else {
							      return res.json().then(function (response) {
								        setTimeout(function () {
									          if (isEmpty(response)) {
                                console.log('INVALID');
										            setCodeInvalid(true);
									          } else {
                                addDiscountCodes(response);
						                    setCodeInvalid(false);
                                setDcInput('');
									          }
								        }, 0);
							      });
						    }
					  }).catch(function (err) {
						    resetDiscountCode();
						    setVerifyingDiscountCode(false);
					  });
		}
    
    return (
        <div className="flex flex-row flex-wrap items-center w-full md:w-auto">
          <div className="mr-2 w-full md:w-auto">
            <input
              className={`mb-4 md:mb-0 w-full md:w-auto md:mt-0 rg-input ${codeInvalid ? 'border border-red-500' : ''}`}
              type="text"
              placeholder="Code eingeben..."
              value={dcInput}
              onChange={event => {
                  setDcInput(event.target.value);
                  setCodeInvalid(false);
              }}/>
          </div>
          <button
            disabled={!dcInput}
            className={`${codeInvalid ? 'rg-button-negative' : (!dcInput ? 'rg-button-blue-disabled' : 'rg-button-blue')} justify-center w-48 flex flex-row`}
            onClick={() => verifyDiscountCode(dcInput)} >
            {verifyingDiscountCode ? <><Spinner/>überprüfe...</> : (codeInvalid ? 'Code ungültig' : (!dcInput ? 'Code eingeben' : 'Code prüfen'))}
          </button>
          {
              discountCodes.map(dc => (
                  <div key={dc.code} className="ml-2 px-4 py-2 flex flex-row items-center rounded-full bg-gold text-white">{dc.code}&nbsp;<button className="font-bold" onClick={() => removeDiscountCode(dc)} >X</button></div>
              ))
          }
        </div>
    );
}
